<template>
  <transition name="fade">
    <div class="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-index-2">
      <div class="bg-white rounded-lg p-4 contenedor-modal-evento w-full">
        <form @submit.prevent="submitForm">
          <!-- Switch para Permitir Duplicados -->
          <div id="espacio_campos">
            <div class="switch-container mb-4 flex items-center">
              <span class="mr-2 text-sm font-medium text-gray-700 cursor-pointer" @click="toggleSwitch">Permitir usuarios duplicados</span>
              <div class="relative cursor-pointer" @click="toggleSwitch">
                <div :class="switchBgClass" class="switch-bg"></div>
                <div :class="switchDotClass" class="switch-dot"></div>
              </div>
            </div>
            
            <transition name="fade">
              <div v-if="camposVisible" id="tabla_campos" class="grid grid-cols-2 gap-4">
                <div v-for="campo in camposRegistro" :key="campo.id_campo" class="campo-registro flex justify-between items-center">
                  <div class="flex-grow">
                    <input type="checkbox" :id="campo.name_campo" v-model="campo.activo" class="hidden" />
                    <label :for="campo.name_campo" :class="{'activo': campo.activo, 'cursor-pointer': true}">
                      {{ campo.nombre_del_campo }}
                    </label>
                  </div>
                  <div class="checkboxes">
                    <input type="checkbox" :id="'required-' + campo.name_campo" v-model="campo.requerido" :disabled="campo.mandatorio" class="form-checkbox checkbox-required" data-label="O" />
                    <input type="checkbox" :id="'mandatorio-' + campo.name_campo" v-model="campo.mandatorio" v-show="!evento.permitir_duplicados" class="form-checkbox checkbox-mandatorio" data-label="M" @change="checkRequerido(campo)" />
                  </div>
                </div>
              </div>
            </transition>
            <div class="rol d-none">
              <input type="radio" id="asistente" name="tipoAsistente" value="asistente" checked v-model="evento.tipo_asistente">
              <label for="asistente" class="btn-radio">Asistente</label>
  
              <input type="radio" id="asistentevirtual" name="tipoAsistente" value="asistentevirtual" v-model="evento.tipo_asistente">
              <label for="asistentevirtual" class="btn-radio">Asistente Virtual</label>
            </div>
          </div>
          <div class="formulario">          
            <!-- <hr class="mb-5"> -->


            <!-- <hr class="mb-5"> -->
            <!-- Nombre del Evento -->
            <div class="mb-4">
              <label for="nombre" class="block text-sm font-medium text-gray-700">Nombre del evento</label>
              <input type="text" id="nombre" v-model="evento.nombre" class="input-style" required>
            </div>
            <!-- Fecha de Inicio -->
            <div class="mb-4">
              <label for="fecha_inicio" class="block text-sm font-medium text-gray-700">Fecha de corte</label>
              <input type="datetime-local" id="fecha_inicio" v-model="evento.fecha_inicio" class="input-style" required>
            </div>
            <!-- Fecha de Fin -->
            <div class="mb-4">
              <label for="fecha_fin" class="block text-sm font-medium text-gray-700">Fecha de fin</label>
              <input type="datetime-local" id="fecha_fin" v-model="evento.fecha_fin" class="input-style" required>
            </div>
            <!-- Código del Evento (opcional) -->
            <div class="mb-4 d-none">
              <label for="codigo" class="block text-sm font-medium text-gray-700">Código (opcional)</label>
              <input type="text" id="codigo" v-model="evento.codigo" class="input-style">
            </div>
            <!-- URL del Evento -->
            <div class="mb-4 d-none">
              <label for="url_evento" class="block text-sm font-medium text-gray-700">URL del evento</label>
              <div class="url">
                <input type="text" class="disabled input-style url-input" disabled="disabled" value="https://">
                <input type="text" id="url_evento" v-model="evento.api.url_evento" class="input-style" placeholder="Agrega solo dominio sin https" @blur="sanitizeURL">
                <input type="text" class="disabled input-style url-context" disabled="disabled" value="/wp-j..">
                
              </div>
            </div>

            <!-- Usuario -->
            <div class="mb-4 d-none">
              <label for="usuario" class="block text-sm font-medium text-gray-700">Usuario</label>
              <input type="text" id="usuario" v-model="evento.api.usuario" class="input-style" >
            </div>

            <!-- Clave -->
            <div class="mb-4 d-none">
              <label for="clave" class="block text-sm font-medium text-gray-700">Clave</label>
              <input type="text" id="clave" v-model="evento.api.acceso" class="input-style" >
            </div>

            <!-- Botones de Acción -->
            <button type="button" @click="$emit('close')" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded">Cancelar</button>
            <button type="submit" class="ml-5 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">Crear Evento</button>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import { useToast } from "vue-toastification";

export default {
  data() {
    return {
      evento: {
        nombre: '',
        fecha_inicio: '',
        fecha_fin: '',
        codigo: '',
        permitir_duplicado: false,
        tipo_asistente: 'asistente',
        api: {
          url_evento: '',
          usuario: '',
          acceso: ''
        }
      },
      camposRegistro: [], // Almacenará los campos de registro activos
      camposVisible: false // Controla la visibilidad de la sección de campos
    };
  },
  computed: {
    switchBgClass() {
      return this.evento.permitir_duplicado ? 'bg-green-500' : 'bg-gray-600';
    },
    switchDotClass() {
      return this.evento.permitir_duplicado ? 'translate-x-9' : 'translate-x-1';
    }
  },
  methods: {
    toggleSwitch() {
      this.evento.permitir_duplicado = !this.evento.permitir_duplicado;
      if (!this.evento.permitir_duplicado && !this.camposVisible) {
        this.camposVisible = true;
      }
    },
    toggleCampos() {
      if (!this.evento.permitir_duplicado) {
        this.camposVisible = true; // Siempre visible cuando no permitimos duplicados
      } else {
        this.camposVisible = !this.camposVisible;
      }
    },
    checkRequerido(campo) {
      if (campo.mandatorio) {
        campo.requerido = true;
      }
    },
    sanitizeURL() {
      let url = this.evento.api.url_evento;
      // Eliminar espacios en blanco
      url = url.replace(/\s+/g, '');
      // Eliminar protocolo
      url = url.replace(/^(?:https?:\/\/)?(?:www\.)?/, '');
      // Eliminar todo después del primer slash
      url = url.replace(/\/.*$/, '');
      // Actualizar el valor visible y el valor que se enviará
      this.evento.api.url_evento = url;
    },

    async submitForm() {
      this.sanitizeURL();
      const camposInfo = this.camposRegistro.map(campo => ({
        label: campo.name_campo,
        activo: campo.activo,
        requerido: campo.requerido || false,
        mandatorio: campo.mandatorio || false
      }));
      const payload = {
        ...this.evento,
        permitir_duplicado: this.evento.permitir_duplicado ? 1 : 0,
        campos: camposInfo,
        tipo_asistente: this.evento.tipo_asistente        
      };
      fetch('/api/eventos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json())
      .then(data => {
        this.toast.success('Evento creado: ' + data.status);
        this.$emit('saved');
        this.$emit('close');
      })
      .catch(() => {
        this.toast.error("Error al crear el evento");
      });
    },
    async fetchCamposRegistro() {
      try {
        const response = await fetch('/api/campos-registro');
        const data = await response.json();
        this.camposRegistro = data.data.map(campo => ({
          ...campo,
          activo: campo.activo === '1', // Asumiendo que la API devuelve '1' o '0' como string
          mandatorio: false  // Inicializar mandatorio a false por defecto
        }));
      } catch (error) {
        this.toast.error('Error al cargar los campos del registro: ' + error.message);
      }
    }
  },
  async created() {
    this.toast = useToast();
    await this.fetchCamposRegistro(); // Load campo data when component is created
    if (!this.evento.permitir_duplicados) {
      this.camposVisible = true;
    }
  },
  setup() {
    const toast = useToast();
    return { toast };
  }
};
</script>

<style lang="sass" scoped>

.d-none 
  display: none!important
.switch-container
  display: flex
  align-items: center
  cursor: pointer
  justify-content: space-between
.switch-bg
  width: 4rem
  height: 2rem
  border-radius: 9999px
  transition: background-color 0.2s

.switch-dot
  width: 1.5rem
  height: 1.5rem
  background-color: white
  border-radius: 50%
  position: absolute
  top: 0.25rem
  transition: transform 0.2s

.input-style
  display: block
  width: 100%
  padding: 0.625rem
  border: 1px solid #cccccc
  border-radius: 0.375rem
  box-shadow: inset 0 1px 1px rgba(0,0,0,0.075)
  &:focus
    outline: none
    border-color: #3182ce
    ring: #3182ce

.btn-blue
  background-color: #2563eb
  &:hover
    background-color: #1d4ed8

.btn-red
  background-color: #ef4444
  &:hover
    background-color: #dc2626


    
.campo-registro label 
  
  display: flex
  justify-content: space-between
  align-items: center
  padding: 10px
  background: gray
  color: white
  border-radius: 5px
  transition: background-color 0.3s

  cursor: pointer // Esto cambia el cursor a un puntero, indicando que el elemento es interactivo
  &::selection 
    background: transparent
  
  &:hover 
    background: darken(gray, 10%) // Oscurece el fondo cuando se pasa el mouse por encima
  



.campo-registro label.activo 
  background: green


.fade-enter-active, .fade-leave-active 
  transition: opacity 0.5s

.fade-enter, .fade-leave-to 
  opacity: 0

.checkbox-required,
.checkbox-mandatorio 
  position: relative
  width: 20px
  height: 20px
  cursor: pointer
  transform: scale(1.5)
  // margin-left: 5px
  margin-left: 15px
  -webkit-appearance: none // Remover el estilo por defecto
  background-color: #eee // Color de fondo por defecto
  border-radius: 4px
  vertical-align: middle
  &:before 
    content: attr(data-label)
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    display: flex
    align-items: center
    justify-content: center
    font-size: 12px
    color: black
  
  &:checked 
    &:before  
      font-weight: bold
      color: #fff
    background-color: green // Cambiar fondo a verde si es obligatorio y está activo
  

hr 
  margin-bottom: 15px

#tabla_campos 
  padding-bottom: 30px

.checkbox-mandatorio:checked 
  background-color: orange // Cambiar fondo a naranja si es mandatorio y está activo
  &:before  
    color: #000
    
.z-index-2
  z-index: 2

.rol 
  display: flex
  justify-content: space-between


.btn-radio 
  display: block
  width: 49%
  padding: 10px
  text-align: center
  cursor: pointer
  border: none
  color: white
  background-color: gray
  transition: background-color 0.3s ease
  border-radius: 5px


input[type="radio"] 
  display: none


input[type="radio"]:checked + label 
  background-color: #008000


input[type="radio"]:not(:checked) + label 
  background-color: #808080
.contenedor-modal-evento
  max-width: 1000px
form
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  .switch-container
    width: 100%
  #espacio_campos,.formulario
    width: 100%
    max-width: 48%
  #espacio_campos
    align-items: center
    display: flex
    justify-content: space-around
    flex-wrap: wrap
    .rol
      width: 100%
.url
  display: flex
  .url-input 
    max-width: 60px
    padding-left: 2px
    padding-right: 2px
  .url-context
    max-width: 60px
    padding-left: 4px
    padding-right: 2px
</style>
